import { Endpoints } from '@/api/ApiEndpoints';
import { Inputs, validationSchema } from '@/entities/HomeHighlightsV2/HomeHighlightsV2FormInputs'

const HomeHighlightsV2 = {
	Plural: 'HomeHighlightsV2',
	Single: 'HomeHighlightsV2',
	Inputs: Inputs,
	FormWithImage: true,
	Relationships: [
		{
			name: 'games',
			endpoint: Endpoints.GAMES_FOR_FILTERS_NEW,
			dataMapping: (response) => {
				response.forEach(element => {
					element['name'] = element.homeTeamName + " - " + element.awayTeamName + " (" + element.gameDate + ")"
				});
				return response;
			},
			mapping: (response) => {
				return response;
			},
		},
		{
			name: 'missions',
			endpoint: Endpoints.ACTIVE_MISSIONS,
			dataMapping: (response) => {
				const list = response?.data ?? response;
				list.forEach(element => {
					element['name'] = element.title;
				});
				return list;
			},
			mapping: (response) => {
				return response?.data ?? response;
			},
		},
		{
			name: 'countryIds',
			endpoint: Endpoints.COUNTRIES_FOR_FILTERS,
			mapping: (response) => response,
			dataMapping: (response) => response,
		},
	],
	ValidationSchema: validationSchema,
	SaveCallBack: () => { /* noop */ }
};

export default HomeHighlightsV2;
